export default {
  title: 'Controllo accessi: {{role}}',
  form: {
    companies: {
      label: 'Visibile per tutti i membri con ruolo {{role}}',
      tooltip: 'Verrà aggiunto ai luoghi in cui il membro del team si è registrato',
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito, aggiorna la pagina',
    failed_to_save_changes: 'Impossibile salvare le modifiche',
    changes_got_saved: 'Modifiche salvate',
  },
};
